<template>
    <div class="bto-sb-widget-favorites">

        <div class="bto-sb-widget-view">
            <div class="bto-sb-widget-favorites-view">
                <live-favorites-widget></live-favorites-widget>
                <upcoming-widget :showMarketsInMatch="true"
                                           :showFavoriteGamesOnly="true"
                                           :showFavorites="true"
                                           :showCategory="true"
                                           :showTournament="true"
                                           :showStatistics="true"/>
            </div>
        </div>
    </div>
</template>
<script>
  import store from '../../store';

  export default {
    name: 'MyFavoritesComponent',
    created() {
      this.dispatch();
    },
    methods: {
      dispatch() {
        store.dispatch('cleanOldFavorites');
        store.dispatch('getFavoriteMatches');
      },
    },
  };
</script>
